<template>
  <div>
    <div class="col-12 p0 py2 my1 break-word">
      <h2 class="m0 caps">
        Participants
      </h2>
    </div>

    <div v-if="contactsToShow.length === 0" class="white-bg col-12 py1 px2 my2 card-top border">
      <div class="flex flex-wrap">
        <div class="col-2 xs-hide flex justify-start items-center">
          <div class="user-icon red-bg">
            <i class="icon flex justify-center white mx-auto line-height-1 relative h1 i-user mt2"></i>
          </div>
        </div>
        <div class="col-10 sm-col-8 flex justify-center flex-column">
          <h4 class="h4 mt1 mb0 center flex items-center justify-center">Il n'y a plus de participants à ajouter</h4>
          <span v-if="isOfferLicense" class="mt1 mb0 center flex items-center justify-center">Si vous ne voyez pas vos participants, ils ont déjà une licence</span>
        </div>
      </div>
    </div>

    <div v-for="(contact, index) in contactsToShow" :key="index" class="pointer white-bg col-12 py1 px2 my2 card-top border" @click="handleClick(contact)">
      <div class="flex flex-wrap">
        <div class="col-2 xs-hide flex justify-start items-center">
          <div :class="['user-icon', { 'light-blue-bg': isSelectedContact(index), 'aqua-bg': !isSelectedContact(index) }]">
            <i class="icon flex justify-center white mx-auto line-height-1 relative h1 i-user mt2"></i>
          </div>
        </div>
        <div class="col-6 sm-col-8">
          <h4 class="h4 mt1 mb0">{{ contact.firstname }} {{ contact.lastname }}</h4>
          <span v-if="contact.birth_date" class="h5">{{ contact.birth_date }} - ({{ participantAge(contact.birth_date) }} ans)</span>
        </div>
        <div class="col-4">
          <div class="flex justify-end mr2 full-height items-center">
            <span :id="`participant-radio-${index}`" :class="['custom-radio flex', { 'selected-item': isSelectedContact(index) }]"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap">
      <div class="col-12 py3 flex flex-wrap justify-end items-center">
        <Button class="col-3 sm-col-12 p1" :action="handleBack" :text="hasProductsStep || hasTerrainsStep? 'Precedent' : 'Retour'" color="grey-bg" />
        <Button v-if="!isLimitedProduct" class="col-5 sm-col-12 p1" :action="handleCreateNewParticipant" text="Créer un nouveau participant" color="light-blue-bg" />
        <Button v-if="!loading" id="button-confirm-contact" class="col-4 sm-col-12 p1" :disabled="selectedContact === -1" :action="confirmContact" text="Suivant" />
        <Button v-else class="col-4 sm-col-12 p1" :disabled="true" icon="icon icon-loader" />
      </div>
    </div>
  </div>
</template>

<script>
import { differenceInYears, getYear, getMonth } from 'date-fns';
import Button from '../../components/elements/Button';

import { changeToPage, handleTariff, hasProductsStep, hasTerrainsStep } from '@/utils/logics';
import { backToAlpha, computedOfferPrices } from '@/utils/utils';

export default {
  components: { Button },
  data () {
    return {
      contacts: this.$store.state.user.contacts,
      participants: this.$store.state.cartItem.participants || [],
      selectedContact: -1,
      participantBeingAdded: null,
      loading: false
    };
  },
  computed: {
    hasProductsStep,
    hasTerrainsStep,
    user () {
      return this.$store.state.user;
    },
    product () {
      return this.$store.state.product;
    },
    products () {
      return this.$store.state.products;
    },
    getSelectedParticipantIndex () {
      const contacts = this.$store.state.user.contacts || [];
      const { currentParticipant } = this.$store.state;
      const index = currentParticipant ? contacts.findIndex(contact => contact.uuid === currentParticipant.uuid) : -1;
      return this.$store.getters.isCartContractRecharge ? 0 : index;
    },
    isLimitedProduct () {
      return !!this.$store.state.product.test_product || !!this.$store.state.product.on_demand;
    },
    isOfferLicense () {
      return this.$store.state.offerInfo.detail.license;
    },
    contactsToShow () {
      let contacts = this.contacts.filter(c => c.uuid === this.participantBeingAdded || !this.participants.some(p => p.uuid === c.uuid));

      if (this.isLimitedProduct && !this.$store.getters.isImpersonateMode) {
        contacts = contacts.filter(c => (c.allowed_products || []).filter(ap => ap.status === 'ACCEPTED').map(ap => ap.product_uuid).includes(this.product.uuid));
      }

      if (this.isOfferLicense) {
        contacts = contacts.filter(c => {
          if (!(c.licenses || []).length) {
            return true;
          }
          const now = new Date();
          const currentYear = getYear(now);

          return (c.licenses || []).some(license => {
            const licenseYear = license?.data?.pegase_license_year ? parseInt(license.data.pegase_license_year) : null;
            return licenseYear && (this.$store.getters.isImpersonateMode && getMonth(now) >= 4 ? currentYear >= licenseYear : currentYear > licenseYear);
          });
        });
      }

      if (this.$store.getters.isCartContractRecharge) {
        contacts = contacts.filter(c => c.uuid === this.$store.state.currentParticipant.uuid);
      }
      return contacts;
    },
    getOfferPrices () {
      const participant = this.contactsToShow[this.selectedContact];
      const offer = this.$store.state.offerInfo;
      return computedOfferPrices(participant, offer);
    }
  },
  created () {
    this.$store.commit('setSelectedPeriod', null);
    this.selectedContact = this.getSelectedParticipantIndex;
  },
  methods: {
    backToAlpha,
    changeToPage,
    handleTariff,
    isSelectedContact (index) {
      return this.selectedContact === index;
    },
    participantAge (birthDate) {
      const date = birthDate.split('/').reverse().join('-');
      return differenceInYears(new Date(), new Date(date));
    },
    handleClick (contact) {
      const participantIndex = this.contactsToShow.findIndex(c => c.uuid === contact.uuid);
      if (participantIndex !== -1) {
        this.selectedContact = participantIndex;
      }
    },
    async confirmContact () {
      // don't make the change of the current participant if it's the same, this way we don't delete any information added
      const contactToSelect = this.contactsToShow[this.selectedContact];
      const { currentParticipant } = this.$store.state;
      this.participantBeingAdded = contactToSelect.uuid;

      if (this.$store.getters.isImpersonateMode && this.isOfferLicense && getMonth(new Date()) >= 4) {
        const currentYear = parseInt(getYear(new Date()));

        if (contactToSelect.licenses.some(license => license?.data?.pegase_license_year && (parseInt(license.data.pegase_license_year) === currentYear))) {
          contactToSelect.nextYearLicense = true;
        }
      }

      if (!currentParticipant || contactToSelect.uuid !== currentParticipant.uuid) {
        this.$store.commit('setCurrentParticipant', { ...contactToSelect });
      }

      const prices = this.getOfferPrices;

      if (prices[0]?.isGymlibTariff) {
        this.changeToPage('Tariffs');
      } else if (prices.length === 1) {
        this.loading = true;
        await this.handleTariff(prices[0].index);
        this.loading = false;
      } else {
        if (prices.some(p => p.period)) {
          const periods = prices.map(p => p.period);

          const diffPeriods = periods.some(p => periods.some(pe => pe.uuid !== p.uuid));

          if (diffPeriods) {
            this.changeToPage('Periods');
            return;
          }
        }
        this.changeToPage('Tariffs');
      }
    },
    handleCreateNewParticipant () {
      this.changeToPage('CreateNewParticipant');
    },
    handleBack () {
      if (!this.$store.state.sessionsCodes.length && !this.$store.getters.isEscapeGame) {
        this.changeToPage('Participants');
      } else if (this.hasTerrainsStep) {
        this.changeToPage('Terrain');
      } else if (this.hasProductsStep) {
        this.changeToPage('Products');
      } else {
        this.backToAlpha();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .user-icon {
    border-radius: 50%;
    width: 60px;
    height: 60px;
    transition: 0.5s;
  }
</style>
